<script setup lang="ts">
import type { User } from '../model/interfaces'

import { faPen, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useUserActions } from '../model/user-actions.hook'

defineOptions({
  name: 'UserRowActions',
})

const props = defineProps<{
  user: User
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManage,
  toggle,
  openEdit,
  openDelete,
} = useUserActions({
  user: computed(() => props.user),
})
</script>

<template>
  <div
    ref="containerRef"
    class="user-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for ${user.name}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="user-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Delete"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./UserRowActions.scss" />
